
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire177f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire177f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $ae9c5cb32b9d3179$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.18accb69.js","dFWCV","sign.ef63525f.jpeg","nBMTc","ventrac.aadc69e3.jpg","gNdDj","plow.66ea6c45.webp","ezd68","stripes2.b656110f.webp","gIak6","stripes3.7f6c1366.webp","iBxmN","index.89a5117a.css"]'));


const $ba30e20475feac5a$export$a9861bd62f48e142 = "af60b2f2f7d84ec266abbe85e39f343e";
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://api.openweathermap.org/data/3.0/onecall?lat=40.5581&lon=-90.0351&units=imperial&appid=";


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    isMenuOpen: false,
    weather: {
        current: {},
        minutely: {}
    }
};
function $0f1d4402dffacf5b$export$c60294ec74f48826() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.isMenuOpen = !$0f1d4402dffacf5b$export$ca000e230c0caa3e.isMenuOpen;
}
const $0f1d4402dffacf5b$var$createCurrentWeatherObject = function(data) {
    const { current: current } = data;
    return {
        feelsLike: `${Math.round(current.feels_like)}\xb0F in Canton`,
        description: current.weather[0].description,
        icon: current.weather[0].icon
    };
};
const $0f1d4402dffacf5b$var$createMinutelyWeatherString = function(data) {
    const { minutely: minutely } = data;
    const rainMinute = minutely?.find((minute)=>minute.precipitation > 0);
    if (rainMinute) {
        const currentTime = Math.floor(Date.now() / 1000);
        const minutesUntilRain = Math.round((rainMinute.dt - currentTime) / 60);
        return `Rain starting in ${minutesUntilRain} minutes.`;
    } else return "No rain expected in the next hour.";
};
const $0f1d4402dffacf5b$export$3b1732125431ecea = async function() {
    try {
        const res = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        const data = await res.json();
        if (!res.ok) throw new Error("Failed to fetch weather data");
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.weather.current = $0f1d4402dffacf5b$var$createCurrentWeatherObject(data);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.weather.minutely = $0f1d4402dffacf5b$var$createMinutelyWeatherString(data);
    } catch (err) {
        console.error(err);
    }
};


class $0e0e6ea8d3f734dc$export$2e2bcd8739ae039 {
    _data;
    render(data) {
        this._data = data;
        const markup = this._generateMarkup();
        this.clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    clear() {
        this._parentElement.innerHTML = "";
    }
}


class $20a0d42f295cccee$var$NavbarView extends (0, $0e0e6ea8d3f734dc$export$2e2bcd8739ae039) {
    #parentElement = document.querySelector(".header");
    #toggleBtn;
    #toggleBtnIcon;
    #mobileMenu;
    #hero;
    #heroBgVideo;
    #pageHero;
    #navHeight;
    constructor(){
        super();
        this.#toggleBtn = this.#parentElement.querySelector(".navbar__toggle-btn");
        this.#toggleBtnIcon = this.#toggleBtn.querySelector(".navbar__toggle-btn-icon");
        this.#mobileMenu = this.#parentElement.querySelector(".navbar__mobile");
        this.#hero = document.querySelector(".hero");
        this.#heroBgVideo = document.querySelector(".hero__video");
        this.#pageHero = document.querySelector(".page-hero");
        this.#navHeight = this.#parentElement.getBoundingClientRect().height;
    }
    render(data) {
        this._data = data;
        this._toggleMobileMenuIcon();
    }
    _toggleMobileMenuIcon() {
        if (!this.#toggleBtnIcon || !this.#mobileMenu) return;
        this.#mobileMenu.classList.toggle("navbar__mobile--open", this._data);
        this.#toggleBtnIcon.classList = this._data ? "fa-solid fa-xmark" : "fa-solid fa-bars";
    }
    addHandlerToggle(handler) {
        if (!this.#toggleBtn) return;
        this.#toggleBtn.addEventListener("click", handler);
    }
    initStickyNav() {
        const stickyNav = (entries)=>{
            const [entry] = entries;
            if (!entry.isIntersecting) this.#parentElement.classList.add("header--sticky");
            else this.#parentElement.classList.remove("header--sticky");
            if (this.#hero) {
                this.#hero.style.paddingTop = `${this.#navHeight}px`;
                this.#heroBgVideo.style.height = `calc(100vh - ${this.#navHeight}px)`;
            }
        };
        // IntersectionObserver configuration
        const mainObserver = new IntersectionObserver(stickyNav, {
            root: null,
            threshold: 0,
            rootMargin: `-${this.#navHeight}px`
        });
        // Observe the hero and pageHero sections
        if (this.#hero) mainObserver.observe(this.#hero);
        if (this.#pageHero) mainObserver.observe(this.#pageHero);
    }
}
var $20a0d42f295cccee$export$2e2bcd8739ae039 = new $20a0d42f295cccee$var$NavbarView();



var $c620b737dc554b2a$exports = {};
$c620b737dc554b2a$exports = new URL("sign.ef63525f.jpeg", import.meta.url).toString();


var $6b4a499953e4f15d$exports = {};
$6b4a499953e4f15d$exports = new URL("ventrac.aadc69e3.jpg", import.meta.url).toString();


var $1ed3a10a059469e8$exports = {};
$1ed3a10a059469e8$exports = new URL("plow.66ea6c45.webp", import.meta.url).toString();


var $883daffe2abab887$exports = {};
$883daffe2abab887$exports = new URL("stripes2.b656110f.webp", import.meta.url).toString();


var $39b96b1e98f2d5cd$exports = {};
$39b96b1e98f2d5cd$exports = new URL("stripes3.7f6c1366.webp", import.meta.url).toString();


const $bd02c871d9c5ba8e$var$imageMap = {
    "sign.jpeg": (0, (/*@__PURE__*/$parcel$interopDefault($c620b737dc554b2a$exports))),
    "ventrac.jpg": (0, (/*@__PURE__*/$parcel$interopDefault($6b4a499953e4f15d$exports))),
    "plow.webp": (0, (/*@__PURE__*/$parcel$interopDefault($1ed3a10a059469e8$exports))),
    "stripes2.webp": (0, (/*@__PURE__*/$parcel$interopDefault($883daffe2abab887$exports))),
    "stripes3.webp": (0, (/*@__PURE__*/$parcel$interopDefault($39b96b1e98f2d5cd$exports)))
};
function $bd02c871d9c5ba8e$export$fe58198efe02b173(imageName) {
    if ($bd02c871d9c5ba8e$var$imageMap[imageName]) return $bd02c871d9c5ba8e$var$imageMap[imageName];
    else {
        console.error(`Image not found: ${imageName}`);
        return null;
    }
}


class $8a160daf7b62a109$var$ImageView extends (0, $0e0e6ea8d3f734dc$export$2e2bcd8739ae039) {
    #targetImgs;
    initLazyLoad() {
        this.#targetImgs = document.querySelectorAll("img[data-src]");
        const handleLazyLoad = function(entries, observer) {
            const [entry] = entries;
            if (!entry.isIntersecting) return;
            const imageName = entry.target.getAttribute("data-src");
            const fullImagePath = (0, $bd02c871d9c5ba8e$export$fe58198efe02b173)(imageName);
            if (!fullImagePath) return;
            entry.target.src = fullImagePath;
            entry.target.addEventListener("load", ()=>{
                entry.target.classList.replace("lazy_img", "lazy_img--loaded");
            });
            observer.unobserve(entry.target);
        };
        const imgObserver = new IntersectionObserver(handleLazyLoad, {
            root: null,
            threshold: 0,
            rootMargin: "50px"
        });
        this.#targetImgs.forEach((img)=>imgObserver.observe(img));
    }
}
var $8a160daf7b62a109$export$2e2bcd8739ae039 = new $8a160daf7b62a109$var$ImageView();



class $0f801eb4e8cf0560$var$ServicesView extends (0, $0e0e6ea8d3f734dc$export$2e2bcd8739ae039) {
    #parentElement;
    #servicesButtons;
    #servicesDescriptions;
    constructor(){
        super();
        this.#parentElement = document.querySelector(".services__list");
        this.#servicesButtons = document.querySelectorAll(".services__list .btn");
        this.#servicesDescriptions = document.querySelectorAll(".services__description");
        if (!this.#parentElement) return;
        window.addEventListener("resize", this._handleResize.bind(this));
    }
    _handleResize() {
        if (window.innerWidth <= 1130) this.#servicesButtons.forEach((b)=>b.style.transform = "translateY(0)");
    }
    addClickHandler(handler) {
        this.#parentElement.addEventListener("click", function(e) {
            const clicked = e.target.closest(".btn");
            if (!clicked) return;
            handler(clicked);
        });
    }
    toggleActiveButton(clicked) {
        this.#servicesButtons.forEach((button)=>{
            button.classList.remove("service--active");
            button.style.transform = "translateY(0)";
        });
        clicked.classList.add("service--active");
        if (window.innerWidth >= 1130) clicked.style.transform = "translateY(-25%)";
        this.#servicesDescriptions.forEach((desc)=>{
            desc.classList.add("hidden");
        });
        const targetDescription = document.querySelector(`.services__description--${clicked.dataset.tab}`);
        if (targetDescription) targetDescription.classList.remove("hidden");
    }
}
var $0f801eb4e8cf0560$export$2e2bcd8739ae039 = new $0f801eb4e8cf0560$var$ServicesView();



class $fe58310d6a499849$var$WeatherView extends (0, $0e0e6ea8d3f734dc$export$2e2bcd8739ae039) {
    _parentElement;
    constructor(){
        super();
        this._parentElement = document.querySelector(".footer__weather");
    }
    _generateMarkup() {
        return `
    <p class="footer__weather-text">Feels like ${this._data.current.feelsLike}.</p>
    <p class="footer__weather-text">${this._data.minutely}</p>
    `;
    }
    renderError(message = "Something went wrong while fetching weather data.") {
        this._parentElement.textContent = message;
    }
}
var $fe58310d6a499849$export$2e2bcd8739ae039 = new $fe58310d6a499849$var$WeatherView();


"use strict";
const $f50bd1f2915ed0f2$var$controlToggleMobileMenu = function() {
    $0f1d4402dffacf5b$export$c60294ec74f48826();
    (0, $20a0d42f295cccee$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.isMenuOpen);
};
const $f50bd1f2915ed0f2$var$controlServices = function(clickedBtn) {
    (0, $0f801eb4e8cf0560$export$2e2bcd8739ae039).toggleActiveButton(clickedBtn);
};
const $f50bd1f2915ed0f2$var$controlWeather = async function() {
    try {
        await $0f1d4402dffacf5b$export$3b1732125431ecea();
        (0, $fe58310d6a499849$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.weather);
    } catch (err) {
        console.error(err);
        (0, $fe58310d6a499849$export$2e2bcd8739ae039).renderError();
    }
};
const $f50bd1f2915ed0f2$var$init = async function() {
    (0, $20a0d42f295cccee$export$2e2bcd8739ae039).addHandlerToggle($f50bd1f2915ed0f2$var$controlToggleMobileMenu);
    (0, $20a0d42f295cccee$export$2e2bcd8739ae039).initStickyNav();
    (0, $8a160daf7b62a109$export$2e2bcd8739ae039).initLazyLoad();
    await $f50bd1f2915ed0f2$var$controlWeather();
    if (document.querySelector(".services__list")) (0, $0f801eb4e8cf0560$export$2e2bcd8739ae039).addClickHandler($f50bd1f2915ed0f2$var$controlServices);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.18accb69.js.map
